import { internal, template } from '../../../vendor/elix.js';

function ButtonShadowMixin(Base) {

  return class ButtonShadow extends Base {

      get [internal.template]() {

        return template.concat(

          super[internal.template],

          template.html`
            <style>
              #inner {
                -moz-box-shadow: var(--tp-box-shadow);
                -webkit-box-shadow: var(--tp-box-shadow);
                box-shadow: var(--tp-box-shadow);
              }

            </style>
          `
        );
      }
    }
  }

export default ButtonShadowMixin;
